module.exports = __webpack_public_path__ + "img/3.324cfc57.png";